import { IContract, IContractProposal } from "../services/bff/coordinator/dto/Contracts.dto"

export const isContractAccepted = (contract: IContract) => {
    return contract.proposals.some(proposal => proposal.wasAccepted)
}

export const getContractAcceptedProposal = (contract: IContract): IContractProposal | undefined => {
    return contract.proposals.find(proposal => proposal.wasAccepted)
}